/* The component reinitializes after Shopify section rendering. It never adds without a click. */
if (!customElements.get('app-complete')) {
  customElements.define('app-complete', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.dataset.enhanced = 'true';
      this.addEventListener('click', event => this.onClick(event), { signal: this.controller.signal });
      this.addEventListener('change', event => {
        const select = event.target.closest('.app-complete__select');
        if (!select) return;
        const card = select.closest('.app-complete__card');
        card.querySelector('[data-app-add]').dataset.variantId = select.value;
        card.querySelector('.app-complete__price').textContent = select.selectedOptions[0].dataset.price;
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
    async onClick(event) {
      const variant = event.target.closest('[data-app-variant]');
      if (variant && !variant.disabled) {
        const card = variant.closest('.app-complete__card');
        if (card.querySelector('[data-app-add]').disabled) return;
        card.querySelectorAll('[data-app-variant]').forEach(button => button.setAttribute('aria-pressed', String(button === variant)));
        card.querySelector('[data-app-add]').dataset.variantId = variant.dataset.variantId;
        card.querySelector('.app-complete__price').textContent = variant.dataset.price;
        const select = card.querySelector('.app-complete__select');
        if (select) select.value = variant.dataset.variantId;
        const image = card.querySelector('.app-complete__image');
        if (image && variant.dataset.image) { image.srcset = ''; image.src = variant.dataset.image; }
        return;
      }
      if (event.target.closest('[data-app-dismiss]')) { this.hidden = true; return; }
      const button = event.target.closest('[data-app-add]');
      if (!button || button.disabled || this.busy) return;
      const card = button.closest('.app-complete__card');
      const variantId = Number(button.dataset.variantId);
      if (!Number.isSafeInteger(variantId) || variantId <= 0) return;
      const status = this.querySelector('[role="status"]');
      const original = button.textContent;
      const root = window.Shopify?.routes?.root || '/';
      this.busy = true;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = this.dataset.loading;
      status.textContent = '';
      let added = false;
      try {
        const currentResponse = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
        if (!currentResponse.ok) throw new Error('cart');
        const current = await currentResponse.json();
        if (current.items.some(item => String(item.product_id) === card.dataset.productId)) {
          status.textContent = this.dataset.duplicate;
          card.hidden = true;
          return;
        }
        const drawer = document.querySelector('cart-drawer');
        const sectionIds = ['cart-drawer', 'cart-icon-bubble'];
        for (const id of ['main-cart-items', 'main-cart-footer']) {
          const node = document.getElementById(id);
          if (node?.dataset.id) sectionIds.push(node.dataset.id);
        }
        window.__markInternalCartCall?.();
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: sectionIds, sections_url: window.location.pathname })
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error('add');
        added = true;
        status.textContent = this.dataset.added;
        card.hidden = true;
        // Missing section HTML must never invite the buyer to add the same item again.
        if (!result.sections?.['cart-drawer'] || !result.sections?.['cart-icon-bubble']) {
          window.location.assign(root + 'cart');
          return;
        }
        for (const id of ['main-cart-items', 'main-cart-footer']) {
          const target = document.getElementById(id);
          const html = target?.dataset.id && result.sections[target.dataset.id];
          if (target && html) {
            const replacement = new DOMParser().parseFromString(html, 'text/html').getElementById(id);
            if (replacement) target.innerHTML = replacement.innerHTML;
          }
        }
        // Native Dawn rendering restores the drawer total, quantities and header badge together.
        if (drawer?.renderContents) {
          drawer.setActiveElement?.(document.getElementById('cart-icon-bubble') || button);
          drawer.renderContents(result);
        } else {
          window.location.assign(root + 'cart');
        }
        document.dispatchEvent(new CustomEvent('app:cart-updated'));
      } catch {
        if (added) window.location.assign(root + 'cart');
        else status.textContent = this.dataset.error;
      } finally {
        this.busy = false;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = original;
      }
    }
  });
}

